import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { settingsApi } from '../api/settingsApi';
import type { SettingsProvider } from '../api/types';

export function useUpdateProvider() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<SettingsProvider> }) =>
      settingsApi.updateProvider(id, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.settings.providers });
    },
  });
}
